// eslint-disable-next-line import/no-cycle
import { StoryblokComponent } from '@storyblok/react';

import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';
import Hero from '@/components/layouts/Hero';

import ArticleListings from './ArticleListing';

const Listing = ({ story, blok, settingsHeader, settingsFooter }) => (
  <>
    <Hero story={story} blok={blok} type="basic">
      <Header theme={'light'} settingsHeader={settingsHeader} />
    </Hero>
    <main role="main" id="main">
      <ArticleListings blok={blok} />
      {blok.body
        ? blok.body.map((blk) => (
            <StoryblokComponent blok={blk} key={blk._uid} />
          ))
        : null}
    </main>
    <Footer settingsFooter={settingsFooter} />
  </>
);

export default Listing;
